import React from "react";
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  LineChart,
  Line,
  Legend,
} from "recharts";

const chartCardStyle = {
  background: "#ffffff",
  border: "1px solid #e4eded",
  borderRadius: "16px",
  padding: "18px",
  minHeight: "360px",
};

const pieColors = ["#008080", "#edb32d", "#333333", "#66b2b2", "#f0cd75"];

const CRMDashboardCharts = ({ charts }) => {
  return (
    <div className="crm-grid" style={{ marginTop: "20px" }}>
      <div style={chartCardStyle}>
        <h3 className="crm-page-title" style={{ fontSize: "18px" }}>
          Pipeline by Stage
        </h3>
        <ResponsiveContainer width="100%" height={280}>
          <BarChart data={charts.stageSummary}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="stage" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="amount" fill="#008080" name="Amount" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div style={chartCardStyle}>
        <h3 className="crm-page-title" style={{ fontSize: "18px" }}>
          Lead Sources
        </h3>
        <ResponsiveContainer width="100%" height={280}>
          <PieChart>
            <Pie
              data={charts.leadSourceSummary}
              dataKey="count"
              nameKey="source"
              outerRadius={100}
              label
            >
              {charts.leadSourceSummary.map((entry, index) => (
                <Cell
                  key={`${entry.source}-${index}`}
                  fill={pieColors[index % pieColors.length]}
                />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </div>

      <div style={chartCardStyle}>
        <h3 className="crm-page-title" style={{ fontSize: "18px" }}>
          Monthly Invoice Revenue
        </h3>
        <ResponsiveContainer width="100%" height={280}>
          <LineChart data={charts.monthlyRevenue}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="amount"
              stroke="#edb32d"
              name="Revenue"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div style={chartCardStyle}>
        <h3 className="crm-page-title" style={{ fontSize: "18px" }}>
          Collections Status
        </h3>
        <ResponsiveContainer width="100%" height={280}>
          <BarChart data={charts.collectionSummary}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="status" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Legend />
            <Bar dataKey="count" fill="#333333" name="Cases" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default CRMDashboardCharts;
